import Step2View from "components/view/signup/step2";
import { useLocation } from "react-router-dom";

const Step2Page = () => {
  const { state: email, pathname } = useLocation();
  return <Step2View email={email} pathname={pathname} />;
};

export default Step2Page;
